 <div class="row">
    <div class="col-md-4" *ngIf="!isInventoryTransfer" hidden>
        <label class="f-label">eDoc Generation Type</label>
            <mat-form-field class="full-width" appearance="outline">
            <mat-select placeholder="Generate - Later" 
                [(ngModel)]="ElectronicProtocolsData.GenerationType"
                [disabled]="screenType == 1" >
                <mat-option *ngFor="let item of eDocGenerationType" [value]="item.value">
                    {{item.key}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-md-4" *ngIf="!isInventoryTransfer">
        <label class="f-label">eDoc Format</label>
        <mat-form-field class="full-width" appearance="outline">
             <mat-select placeholder="eDoc Format" [(ngModel)]="ElectronicProtocolsData.MappingID"
                [disabled]="screenType == 1">
                    <mat-option *ngFor="let item of eDocFormat" [value]="item.value">
                        {{item.key}}
                    </mat-option>
             </mat-select>
        </mat-form-field>
    </div>
    <div class="col-md-4" *ngIf="!isInventoryTransfer">
        <label class="f-label">Document Status</label>
        <mat-form-field class="full-width" appearance="outline">
            <mat-select placeholder="Waiting" [(ngModel)]="waitingStatus" [disabled]="screenType == 1">
                <mat-option *ngFor="let item of docStatus" [value]="item.value">
                    {{item.key}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-md-4">
        <label class="f-label">E-Way Bill Details</label>
        <mat-form-field class="full-width" appearance="outline">
            <input type="text" matInput readonly placeholder="..." (click)="showEWayBillPopup()">
        </mat-form-field>
    </div>
</div>